import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const RIDE_REQUEST_VIEWS_VOCABULARIES = [
    vocabulary('request_group.lane_status', '@vello/api-client LaneStatus', {
        searching: L('Procurando', 'Searching', 'Buscando', 'In ricerca'),
        exhausted: L('Sem mais motoristas', 'No more drivers', 'Sin más conductores', 'Nessun altro autista'),
        cancelled: L('Cancelada', 'Cancelled', 'Cancelada', 'Annullata'),
        won: L('Escolhida', 'Chosen', 'Elegida', 'Scelta'),
    }),
    vocabulary('ride_support.query_kind', '@vello/api-client RideSupportQueryKind', {
        ride_id: L('ID da corrida', 'Ride ID', 'ID del viaje', 'ID della corsa'),
        ride_code: L('Código da corrida', 'Ride code', 'Código del viaje', 'Codice della corsa'),
        account_id: L('ID da conta', 'Account ID', 'ID de la cuenta', 'ID dell’account'),
        phone: L('Telefone', 'Phone', 'Teléfono', 'Telefono'),
    }),
    vocabulary('ride_support.section', '@vello/api-client RideSupportSection', {
        fareBreakdown: L('Composição da tarifa', 'Fare breakdown', 'Desglose de la tarifa', 'Dettaglio della tariffa'),
        payment: L('Pagamento', 'Payment', 'Pago', 'Pagamento'),
        dispatch: L('Despacho', 'Dispatch', 'Despacho', 'Assegnazione'),
        rider: L('Passageiro', 'Rider', 'Pasajero', 'Passeggero'),
        driver: L('Motorista', 'Driver', 'Conductor', 'Autista'),
        cases: L('Casos ligados', 'Linked cases', 'Casos vinculados', 'Casi collegati'),
        cash: L('Dinheiro', 'Cash', 'Efectivo', 'Contanti'),
    }),
    vocabulary('rider_cancellation.stage', '@vello/api-client CancelStage', {
        PRE_ASSIGNMENT: L('Antes de ter motorista', 'Before a driver is assigned', 'Antes de tener conductor', 'Prima dell’assegnazione dell’autista'),
        AFTER_ASSIGNMENT: L('Depois de ter motorista', 'After a driver is assigned', 'Después de tener conductor', 'Dopo l’assegnazione dell’autista'),
        ON_BOARD: L('Com o passageiro a bordo', 'With the rider on board', 'Con el pasajero a bordo', 'Con il passeggero a bordo'),
        ENDED: L('Depois de terminada', 'After it ended', 'Después de terminado', 'Dopo la fine'),
    }),
    vocabulary('rider_loyalty.subscription_state', '@vello/api-client SubscriptionState', {
        ACTIVE: L('Ativa', 'Active', 'Activa', 'Attiva'),
        CANCELLED: L('Cancelada', 'Cancelled', 'Cancelada', 'Annullata'),
        EXPIRED: L('Expirada', 'Expired', 'Vencida', 'Scaduta'),
    }),
    vocabulary('ride.stop_type', '@vello/api-client StopType', {
        pickup: L('Embarque', 'Pickup', 'Recogida', 'Ritiro'),
        stop: L('Parada', 'Stop', 'Parada', 'Fermata'),
        destination: L('Destino', 'Destination', 'Destino', 'Destinazione'),
    }),
    vocabulary('ride.receipt_settlement', '@vello/api-client RideReceiptSettlement', {
        CASH_PENDING_CONFIRMATION: L('Dinheiro aguardando confirmação', 'Cash awaiting confirmation', 'Efectivo esperando confirmación', 'Contanti in attesa di conferma'),
        CASH_CONFIRMED: L('Dinheiro confirmado', 'Cash confirmed', 'Efectivo confirmado', 'Contanti confermati'),
        PAYMENT_RECORDED: L('Pagamento registrado', 'Payment recorded', 'Pago registrado', 'Pagamento registrato'),
        PAYMENT_NOT_RECORDED: L('Pagamento não registrado', 'Payment not recorded', 'Pago no registrado', 'Pagamento non registrato'),
    }),
];
//# sourceMappingURL=ride-request-views.js.map